import { DateTime } from 'luxon';

export function formatBillingDate(date: Date | string | null) {
    return date === null
        ? '-'
        : typeof date === 'string'
          ? DateTime.fromISO(date).isValid
              ? DateTime.fromISO(date).setZone('America/Toronto').toFormat('MMM dd, yyyy')
              : DateTime.fromSQL(date).setZone('America/Toronto').toFormat('MMM dd, yyyy')
          : DateTime.fromJSDate(date).setZone('America/Toronto').toFormat('MMM dd, yyyy');
}

export function formatBillingExportDate(date: Date | string | null) {
    return date === null
        ? '-'
        : typeof date === 'string'
          ? DateTime.fromISO(date).isValid
              ? DateTime.fromISO(date).setZone('America/Toronto').toFormat("yyyy-MM-dd'T'HH:mm:ss")
              : DateTime.fromSQL(date).setZone('America/Toronto').toFormat("yyyy-MM-dd'T'HH:mm:ss")
          : DateTime.fromJSDate(date).setZone('America/Toronto').toFormat("yyyy-MM-dd'T'HH:mm:ss");
}
